(() => {
  const normalize = value => value.toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i');
  function init(root) {
    if (root.dataset.ready) return;
    const cards = [...root.querySelectorAll('[data-archive-card]')];
    const nav = [...root.querySelectorAll('[data-archive-filter]')];
    if (!nav.length) { root.dataset.ready = 'true'; return; }
    const input = root.querySelector('[data-archive-search]');
    const count = root.querySelector('[data-archive-count]');
    const empty = root.querySelector('[data-archive-empty]');
    const copies = [...root.querySelectorAll('[data-archive-copy]')];
    const select = root.querySelector('[data-archive-select]');
    const allowed = new Set(nav.map(a => a.dataset.archiveFilter));
    let category = 'all';
    function render() {
      select.value = category;
      const query = normalize(input.value.trim());
      let visible = 0;
      for (const card of cards) {
        card.hidden = !(category === 'all' || card.dataset.group === category) || !normalize(card.textContent).includes(query);
        if (!card.hidden) visible++;
      }
      nav.forEach(a => { if (a.dataset.archiveFilter === category) a.setAttribute('aria-current','true'); else a.removeAttribute('aria-current'); });
      copies.forEach(c => { c.hidden = c.dataset.archiveCopy !== category; });
      count.textContent = `${visible} / ${cards.length} tasarım`;
      empty.hidden = visible !== 0;
    }
    function fromUrl() {
      const params = new URL(location.href).searchParams;
      const chosen = params.get('archive_category');
      category = allowed.has(chosen) ? chosen : 'all';
      input.value = params.get('archive_q') || '';
      render();
    }
    function updateUrl(push) {
      const url = new URL(location.href);
      if (category === 'all') url.searchParams.delete('archive_category'); else url.searchParams.set('archive_category',category);
      if (input.value.trim()) url.searchParams.set('archive_q',input.value.trim()); else url.searchParams.delete('archive_q');
      history[push?'pushState':'replaceState']({},'',url);
    }
    nav.forEach(a => a.addEventListener('click',e => { e.preventDefault(); category=a.dataset.archiveFilter; render(); updateUrl(true); }));
    input.addEventListener('input',() => {render();updateUrl(false);});
    select.addEventListener('change',() => {category=select.value;render();updateUrl(true);});
    root.querySelector('[data-archive-reset]').addEventListener('click',() => {input.value='';category='all';render();updateUrl(true);input.focus();});
    window.addEventListener('popstate',fromUrl);
    fromUrl();
    root.dataset.ready = 'true';
  }
  document.querySelectorAll('[data-archive-root]').forEach(init);
  document.addEventListener('shopify:section:load',e => e.target.querySelectorAll('[data-archive-root]').forEach(init));
})();
